import React, { useState, useRef } from "react";
import emailjs from "@emailjs/browser";

function PreRegisterModal({ isModalOpen, onClose }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const form = useRef(null);

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID,
        form.current,
        process.env.REACT_APP_PUBLIC_KEY
      )
      .then(
        () => {
          console.log("SUCCESS!");
        },
        (error) => {
          console.log("FAILED...", error.text);
        }
      );
  };

  if (!isModalOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center overflow-x-hidden">
      <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-lg mx-4">
        <button onClick={onClose} className="float-right text-xl font-semibold">
          &times;
        </button>
        <h2 className="text-xl font-bold mb-4 text-custom-red">Subscribe</h2>
        <h2 className="text-lg font-bold mb-4">
          Sign up to be the first to get updates
        </h2>
        <form ref={form} onSubmit={sendEmail} className="space-y-4">
          <input
            type="text"
            value={name}
            name="user_name"
            onChange={(e) => setName(e.target.value)}
            placeholder="Name"
            className="w-full p-2 border border-gray-300 rounded"
          />
          <input
            type="email"
            value={email}
            name="email"
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            className="w-full p-2 border border-gray-300 rounded"
          />
          <button
            type="submit"
            className="w-full bg-red-500 text-white font-bold py-2 px-4 rounded-full"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
}

export default PreRegisterModal;

